import { nextTick } from 'vue';
import type { NavigationGuardWithThis, RouteLocationNormalized } from 'vue-router';

import { useUserStore } from '@/entities/user';
import { RouterPages } from '@/shared/router';

const authGuard: NavigationGuardWithThis<undefined> = async (to: RouteLocationNormalized) => {
  const userStore = useUserStore();
  if (!userStore.isFetched) {
    await userStore.fetchUser();
    await nextTick();
  }

  if (to.meta.ignoreAuth) {
    return;
  }

  if (userStore.isAuth) {
    return;
  }

  return {
    name: RouterPages.INDEX,
    query: { return_to: to.fullPath },
  };
};

export { authGuard };
